import {
  anotherBankImage,
  feedbackSentImage,
  fileImage,
  pdfFileImage,
} from '@themes/shared/images';

const IMAGES_SETS = {
  default: {
    anotherBank: anotherBankImage,
    feedbackSent: feedbackSentImage,
    file: fileImage,
    pdfFile: pdfFileImage,
  },
  voltex: {
    anotherBank: anotherBankImage,
    feedbackSent: feedbackSentImage,
    file: fileImage,
    pdfFile: pdfFileImage,
  },
  rio: {
    anotherBank: anotherBankImage,
    feedbackSent: feedbackSentImage,
    file: fileImage,
    pdfFile: pdfFileImage,
  },
};

export default IMAGES_SETS;
